// src/components/Layout.js
import React from "react";
import { motion } from "framer-motion";

export default function Layout({ children }) {
  const currentYear = new Date().getFullYear();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#0d1117", // 🎨 Fondo profesional liso
        fontFamily: "'Inter', 'Segoe UI', sans-serif",
        color: "#e5e5e5",
      }}
    >
      {/* HEADER */}
      <motion.header
        initial={{ y: -80 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.4 }}
        style={{
          background: "rgba(13,17,23,0.75)", // Transparente premium
          backdropFilter: "blur(12px)",
          borderBottom: "1px solid rgba(255,255,255,0.05)",
          padding: "14px 22px",
          position: "sticky",
          top: 0,
          zIndex: 50,
          boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* LOGO + NOMBRE */}
          <motion.div
            whileHover={{ scale: 1.03 }}
            onClick={() => (window.location.href = "/")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              cursor: "pointer",
            }}
          >
            <img
              src="/logo.png"
              alt="NewStyle23 Logo"
              style={{
                width: "46px",
                height: "46px",
                borderRadius: "10px",
                objectFit: "cover",
                boxShadow: "0px 4px 12px rgba(251,191,36,0.25)",
              }}
            />

            <div>
              <h1
                style={{
                  margin: 0,
                  fontSize: "20px",
                  fontWeight: "700",
                  background: "linear-gradient(90deg, #fbbf24, #f59e0b)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                NewStyle23
              </h1>

              <p
                style={{
                  margin: 0,
                  marginTop: "2px",
                  fontSize: "12px",
                  opacity: 0.55,
                }}
              >
              
              </p>
            </div>
          </motion.div>

          {/* INDICADOR */}
          <div
            style={{
              padding: "6px 14px",
              background: "rgba(34,197,94,0.18)",
              border: "1px solid rgba(34,197,94,0.4)",
              borderRadius: "20px",
              fontSize: "11px",
              color: "#86efac",
              fontWeight: 600,
            }}
          >
            ✔ Disponible
          </div>
        </div>
      </motion.header>

      {/* MAIN */}
      <main
        style={{
          flex: 1,
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "20px",
        }}
      >
        {children}
      </main>

      {/* FOOTER */}
      <footer
        style={{
          background: "#0f141b",
          borderTop: "1px solid rgba(255,255,255,0.05)",
          padding: "40px 20px",
          marginTop: "40px",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "40px",
          }}
        >
          {/* ABOUT */}
          <div>
            <h3 style={{ color: "#fbbf24", fontSize: "16px", marginBottom: "10px" }}>
              NewStyle23
            </h3>
            <p style={{ opacity: 0.6, lineHeight: "1.6", fontSize: "13px" }}>
              Barbería con sistema de reservas inteligente, confirmación por WhatsApp y
              recordatorios automáticos.
            </p>
          </div>

          {/* HORARIOS */}
          <div>
            <h3 style={{ color: "#fbbf24", fontSize: "16px", marginBottom: "10px" }}>
              Horarios
            </h3>
            <ul style={{ opacity: 0.6, listStyle: "none", padding: 0, fontSize: "13px" }}>
              <li>Martes a viernes: 10:00-14:00 / 16:00-21:00</li>
              <li>Lunes: 16:00-21:00</li>
              <li>Sábado: 10:00-14:00</li>
            </ul>
          </div>

          {/* CONTACTO */}
          <div>
            <h3 style={{ color: "#fbbf24", fontSize: "16px", marginBottom: "10px" }}>
              Contacto
            </h3>
            <div style={{ opacity: 0.6, fontSize: "13px", display: "grid", gap: "6px" }}>
              <a
                href="https://wa.me/34675722551"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#86efac", fontWeight: 600, textDecoration: "none" }}
              >
                💬 WhatsApp: +34 675 722 551
              </a>
              <span>📍 Calle Tucán, nº4</span>
              <span>📍 41749 El Cuervo, Sevilla</span>
            </div>
          </div>
        </div>

        {/* COPYRIGHT */}
        <div
          style={{
            marginTop: "30px",
            textAlign: "center",
            opacity: 0.35,
            fontSize: "12px",
          }}
        >
          © {currentYear} NewStyle23 · Desarrollado por{" "}
          <a
            href="https://topindev.cloud"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#fbbf24", fontWeight: 600 }}
          >
            TopinDev
          </a>
        </div>
      </footer>
    </div>
  );
}
